import "../componnetsCss/User.css";
import React, { useEffect, useState } from "react";
import { app } from "../Firebase";

import {
  getDatabase,
  ref,
  onValue,
  update,
  limitToFirst,
} from "firebase/database";
import Image from "react-bootstrap/Image";

import { Col, Container, Row } from "react-bootstrap";
import {
  FaArrowAltCircleUp,
  FaArrowUp,
  FaMoneyBill,
  FaMoneyCheckAlt,
  FaPeopleArrows,
  FaUser,
  FaUserEdit,
  FaUserPlus,
} from "react-icons/fa";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Figure from "react-bootstrap/Figure";
import Giveaway from "./Giveaway";

const UserActive = () => {
  const [plusval, setplusval] = useState();
  const [testing, settesting] = useState(1);

  useEffect(() => {
    const readDataUser = () => {
      const db = getDatabase(app);
      const starCountRef = ref(db);
      onValue(starCountRef, (snapshot) => {
        const data = snapshot.val();
        console.log(data.WithdrewlAmount.amount);
        setplusval(data.WithdrewlAmount.amount);
      });
    };
    readDataUser();
  }, []);
  const a = () => {
    if (plusval > 0) {
      setTimeout(() => {
        for (let index = 0; index < testing; index++) {
          console.log(index);
          const number = [550, 750, 950, 550, 750, 1600, 1000, 2020];
          const randomValue = number[Math.floor(Math.random())];
          setplusval(plusval + randomValue);
        }
      }, 6500);
      const db = getDatabase(app);
      const as = ref(db, `WithdrewlAmount`);
      update(as, {
        amount: plusval,
      });
    }
  };
  a();



  // 200+ random values ka array (ya aap apni marzi ki values daal dein)
  const userCounts = [
  "1500", "2200", "2500", "2900", "1900", "1800", "2000", "2780", "1540", "2610", 
  "1675", "2950", "1820", "2145", "2390", "2880", "1730", "2560", "1915", "2050", 
  "2230", "2710", "1590", "2480", "1850", "2120", "2350", "2980", "1620", "2650", 
  "1770", "2520", "1980", "2090", "2270", "2750", "1510", "2440", "1890", "2170", 
  "2310", "2920", "1650", "2690", "1710", "2580", "1940", "2020", "2210", "2790", 
  "1560", "2410", "1870", "2190", "2330", "2970", "1680", "2630", "1750", "2550", 
  "1960", "2070", "2250", "2730", "1530", "2460", "1810", "2130", "2370", "2940", 
  "1610", "2670", "1790", "2510", "1995", "2030", "2290", "2770", "1580", "2430", 
  "1840", "2110", "2340", "2990", "1640", "2620", "1720", "2590", "1930", "2010", 
  "2220", "2810", "1570", "2490", "1830", "2160", "2380", "2910", "1690", "2640", 
  "1760", "2540", "1970", "2060", "2240", "2720", "1520", "2450", "1860", "2180", 
  "2320", "2960", "1630", "2660", "1740", "2570", "1950", "2040", "2260", "2740", 
  "1550", "2420", "1880", "2150", "2360", "2930", "1660", "2680", "1780", "2530", 
  "1920", "2080", "2280", "2760", "1505", "2405", "1805", "2105", "2305", "2905", 
  "1605", "2605", "1705", "2505", "1905", "2015", "2215", "2805", "1535", "2435", 
  "1835", "2135", "2335", "2935", "1635", "2635", "1735", "2535", "1935", "2035", 
  "2235", "2835", "1555", "2455", "1855", "2155", "2355", "2955", "1655", "2655", 
  "1755", "2555", "1955", "2055", "2255", "2855", "1575", "2475", "1875", "2175", 
  "2375", "2975", "1670", "2675", "1775", "2575", "1975", "2075", "2275", "2875", 
  "1595", "2495", "1895", "2195", "2395", "2995", "1615", "2615", "1715", "2515", 
  "1910", "2025", "2225", "2825", "1545", "2445", "1845", "2145", "2345", "2945", 
  "1645", "2645", "1745", "2545", "1945", "2045", "2245", "2845", "1565", "2465", 
  "1865", "2165", "2365", "2965", "1665", "2665", "1765", "2565", "1965", "2065", 
  "2265", "2865", "1585", "2485", "1885", "2185", "2385", "2985", "1625", "2625", 
  "1725", "2525", "1925", "2095", "2295", "2895", "1525", "2415", "1815", "3000"
];

  const [displayValue, setDisplayValue] = useState("20K");
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    const updateInterval = setInterval(() => {
      setIsUpdating(true); // Animation start

      setTimeout(() => {
        const randomValue = userCounts[Math.floor(Math.random() * userCounts.length)];
        setDisplayValue(randomValue);
        setIsUpdating(false); // Animation end
      }, 500); // 0.5s ka delay transition ke liye

    }, 5000); // Har 5 second baad value change hogi

    return () => clearInterval(updateInterval);
  }, []);
  // const a = () => {

  //   setTimeout(() => {
  //     const randomValue = number[Math.floor(Math.random() * number.length)];
  //     console.log(randomValue);
  //     setplusval(plusval + randomValue);
  //   }, 10000);
  // };
  // a();
  // const number = [250, 350, 450, 550, 750];

  // setInterval(() => {
  //   const randomValue = number[Math.floor(Math.random() * number.length)];
  //   setIncressVal(plusval + randomValue);
  // }, 9000);
  // const db = getDatabase(app);
  // const as = ref(db, `WithdrewlAmount`);
  // update(as, {
  //   amount: IncressVal,
  // });

  // const number = [250, 350, 450, 550, 750];
  // const randomValue = number[Math.floor(Math.random() * number.length)];
  // console.log(randomValue);

  return (
    <div className="dashboard-container">
      <div className="stats-grid">

        {/* Card 1: Active Users */}
        <div className="stats-grid">
          {/* Card 1: Dynamic Active Users */}
          <div className={`stat-card ${isUpdating ? 'refreshing' : ''}`}>
            <div className="card-header">
              <div className="icon-wrapper blue-glow">
                <FaUserPlus />
              </div>
              <h3 className="card-title">Active Users</h3>
            </div>
            <div className="card-content">
              <h2 className="stat-value pulse-text">{displayValue}</h2>
              <span className="stat-label">Live Community</span>
            </div>

            {/* Chota sa Live Indicator */}
            <div className="live-indicator">
              <span className="dot"></span> Updating Live
            </div>
          </div>
        </div>

        {/* Card 2: Today Withdrew */}
        <div className="stat-card highlight">
          <div className="card-header">
            <div className="icon-wrapper green-glow">
              <FaMoneyCheckAlt />
            </div>
            <h3 className="card-title">Today Withdrew</h3>
          </div>
          <div className="card-content">
            <h2 className="stat-value">
              {plusval} <span className="currency">Rs</span>
              <FaArrowUp className="trend-icon" />
            </h2>
            <span className="stat-label">Real-time Payouts</span>
          </div>
        </div>

      </div>
    </div>
  );
};

export default UserActive;
